export default {
  TOPICS: [
    { text: "Agility", value: "agility" },
    { text: "Culture", value: "culture" },
    { text: "Design Thinking", value: "design-thinking" },
    {
      text: "Diversity, Equity, Inclusion and Belonging",
      value: "diversity-equity-inclusion-belonging",
    },
    {
      text: "Employee Experience and Engagement",
      value: "employee-experience-and-engagement",
    },
    { text: "Future of Work", value: "future-of-work" },
    { text: "HR Strategy", value: "hr-strategy" },
    { text: "Innovation", value: "innovation" },
    { text: "Job seekers", value: "job-seekers" },
    { text: "Leadership", value: "leadership" },
    { text: "Learning and Development", value: "learning-and-development" },
    { text: "Marketing and Branding", value: "marketing-and-branding" },
    {
      text: "People Science and People Analytics ",
      value: "people-science-analytics",
    },
    { text: "Performance Management", value: "performance-management" },
    { text: "Recruitment and Talent", value: "recruitment-and-talent" },
    { text: "Remote Work", value: "remote-work" },
    {
      text: "Strategy and Transformation",
      value: "strategy-and-transformation",
    },
    { text: "Technology", value: "technology" },
    { text: "Wellness and Wellbeing", value: "wellness-and-wellbeing" },
  ],
  PROFICIENCY_LEVEL: ["Beginner", "Intermediate", "Export"],
  SPECIALTIES: [
    "Leadership",
    "Community cultivator",
    "Leadership",
    "Human Resources",
    "Human Resources",
    "Professor",
    "Recruiting",
    "Recruiting",
    "Recruiting",
    "Leadership",
    "Leadership",
    "Technology",
  ],
  JOB_LEVELS: [
    {
      label: "C-Suite",
      value: "C-Suite",
    },
    {
      label: "VP or SVP",
      value: "VP or SVP",
    },
    {
      label: "Director",
      value: "Director",
    },
    {
      label: "Manager",
      value: "Manager",
    },
    {
      label: "Professional",
      value: "Professional",
    },
    {
      label: "Junior",
      value: "Junior",
    },
  ],
  WORK_AREAS: [
    {
      label: "Compensation/Benefits",
      value: "Compensation/Benefits",
    },
    {
      label: "Culture/Employee Experience",
      value: "Culture/Employee Experience",
    },
    {
      label: "Labor relations/Policy",
      value: "Labor relations/Policy",
    },
    {
      label: "Learning / Talent Development",
      value: "Learning / Talent Development",
    },
    {
      label: "Organizational Change Management / Transformation",
      value: "Organizational Change Management / Transformation",
    },
    {
      label: "Organizational Design",
      value: "Organizational Design",
    },
    {
      label: "People Analytics",
      value: "People Analytics",
    },
    {
      label: "Talent acquisition/recruitment",
      value: "Talent acquisition/recruitment",
    },
    {
      label: "Talent Management",
      value: "Talent Management",
    },
    {
      label: "All of the Above",
      value: "all",
    },
  ],
  ORG_SIZES: [
    {
      label: "1-100",
      value: "1-100",
    },
    {
      label: "101 - 500",
      value: "101 - 500",
    },
    {
      label: "501-1000",
      value: "501-1000",
    },
    {
      label: "1001 - 5000",
      value: "1001 - 5000",
    },
    {
      label: "5001-10000",
      value: "5001-10000",
    },
    {
      label: "Over 10000",
      value: "Over 10000",
    },
  ],
  LOCATIONS: [
    {
      label: "Remote",
      value: "remote",
    },
    {
      label: "Hybrid",
      value: "hybrid",
    },
    {
      label: "On-Site",
      value: "on-site",
    },
  ],
};
